export default "__VITE_ASSET__udVZ7xX1__"